import { useEffect, useState } from "react";

import { API_URL } from "src/service/config";
import AudioListCard from "./AudioListCard";
import LanguageFilter from "../Lesson/LessonFilter";
import Layout from "@components/layout";
// import { IPaginator } from "src/types";
import PaginatorBtn from "@components/pagination/paginator.button";
import { getFromMemory } from "@utils/storage.utils";
import { getRequest } from "src/service/api-services/api-services";

export interface IPaginator {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

export interface IAudio {
  id: string;
  code: string;
  translation: string;
  language: string;
  localText: string;
  url: string;
}

export interface AudioResponse {
  status: string;
  message: string;
  result: {
    pagination: IPaginator;
    audios: IAudio[];
  };
}

function ViewAudioAssets() {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    getFromMemory("language") || "",
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [paginator, setPaginatorData] = useState<IPaginator>();
  const [openAudioCode, setOpenAduioCode] = useState<string | null>(null);
  const [audioList, setAudioList] = useState<IAudio[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const fetchAudioList = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        if (selectedLanguage) params.append("language", selectedLanguage);
        if (query) params.append("search", query);
        params.append("page", String(currentPage));
        params.append("limit", "50");

        const response = await getRequest<AudioResponse>(
          `${API_URL}/audios?${params.toString()}`,
        );
        setAudioList(response.result.audios);
        setPaginatorData(response.result.pagination);
        setError(undefined);
      } catch (error) {
        setError(error instanceof Error ? error.message : "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchAudioList();
  }, [query, currentPage, selectedLanguage]);

  return (
    <Layout>
      <div className="bg-gray-50 min-h-screen py-8">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-extrabold text-center mb-10 text-brand">
            Audio Assets
          </h1>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-6">
            <input
              className="w-full md:w-1/2 px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-brand"
              placeholder="Search for a audios..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />

            <LanguageFilter
              selectedLanguage={selectedLanguage}
              onLanguageChange={setSelectedLanguage}
            />
          </div>

          {loading && (
            <p className="text-center text-gray-500">Loading audio assets...</p>
          )}

          {!loading && error && (
            <p className="text-center text-red-500">{error}</p>
          )}

          {!loading && !error && audioList.length === 0 && (
            <p className="text-center text-gray-600">No audio available.</p>
          )}

          <div className="flex flex-row mb-6">
            <div className="mr-2">
              <button
                onClick={() =>
                  (window.location.href = `/dashboard/asset/declear/audio`)
                }
                className="bg-brand text-white px-4 py-2 rounded-md hover:bg-brand-dark transition"
              >
                Declear Assets
              </button>
            </div>
            <div>
              <button
                onClick={() =>
                  (window.location.href = `/dashboard/assets/upload`)
                }
                className="bg-brand text-white px-4 py-2 rounded-md hover:bg-brand-dark transition"
              >
                Upload Content
              </button>
            </div>
          </div>

          {!loading && !error && audioList.length > 0 && (
            <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6 mt-8">
              {audioList.map((audio, index) => (
                <AudioListCard
                  key={index}
                  selectedAudio={audio}
                  onAudioChange={(val) =>
                    setOpenAduioCode(val ? audio.code : null)
                  }
                  IsAudioSelected={openAudioCode === audio.code}
                />
              ))}
            </section>
          )}
        </div>

        {paginator && !loading && (
          <PaginatorBtn setCurrentPage={setCurrentPage} paginator={paginator} />
        )}
      </div>
    </Layout>
  );
}

export default ViewAudioAssets;
